<template>
  <v-container fluid>
    <v-card>
      <v-card-title>{{ $vuetify.lang.t('$vuetify.subscription_plans.create_title') }}</v-card-title>

      <v-card-text v-if="subscriptionPlansLoading">
        <subscription-plan-form-skeleton />
      </v-card-text>

      <v-card-text v-else>
        <subscription-plan-form
          :initial-data="form"
          :existing-plans="subscriptionPlans"
          :loading="saving"
          :submit-text="$vuetify.lang.t('$vuetify.common.create')"
          @submit="handleCreate"
          @cancel="goBack"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { 
  CREATE_SUBSCRIPTION_PLAN , 
  ADD_ALERT ,
  LOAD_ALL_SUBSCRIPTION_PLANS
} from "@/store/_actiontypes";

import { createEmptyPlanForm } from "@/helpers/subscriptionPlan";
import SubscriptionPlanForm from "@/components/SubscriptionPlans/SubscriptionPlanForm.vue";
import SubscriptionPlanFormSkeleton from "@/components/SubscriptionPlans/SubscriptionPlanFormSkeleton.vue";
import getEnv from "@/config/env";


export default {
  name: "SubscriptionPlanCreate",

  components: {
    SubscriptionPlanForm,
    SubscriptionPlanFormSkeleton,
  },

  data() {
    return {
      saving: false,
      form: createEmptyPlanForm(),
    };
  },
  async created() {
    try {
      if (!this.subscriptionPlans?.length) {
        let subscription = null;

        if (getEnv("VUE_APP_CAPTCHA_ENABLED")) {
          subscription = await this.$recaptcha.execute("subscription");
        }

        await this.loadPlans({ recaptcha_token: subscription });
      }
    } catch (error) {
      console.log("error",error)

      this.addAlert({
        message: this.$vuetify.lang.t(
          "$vuetify.subscription_plans.messages.load_failed"
        ),
        color: "error",
      });
    }
  },

  computed: {
    ...mapGetters("subscription_plans", [
      "subscriptionPlans",
      "subscriptionPlan", 
      "subscriptionPlansLoading",
      "subscriptionPlansErrorMessage",
      "subscriptionPlansSuccessMessage"
    ]),
  },

  methods: {
    ...mapActions("subscription_plans", {
      createPlan: CREATE_SUBSCRIPTION_PLAN,
      loadPlans: LOAD_ALL_SUBSCRIPTION_PLANS,
    }),
    
    ...mapActions("alert", {
      addAlert: ADD_ALERT
    }),

    goBack() {
      this.$router.push({ name: "SubscriptionPlans" });
    },

    async handleCreate(formData) {
      this.saving = true;

      try {
        await this.createPlan(formData);

        this.addAlert({
          message: this.subscriptionPlansSuccessMessage
            || this.$vuetify.lang.t('$vuetify.subscription_plans.messages.create_success'),
          color: "success",
        });

        this.goBack();
        
      } catch (error) {

        this.addAlert({
          message: this.subscriptionPlansErrorMessage
            || this.$vuetify.lang.t('$vuetify.subscription_plans.messages.create_failed'),
          color: "error",
        });

      } finally {
        this.saving = false;
      }
    },
  },
};
</script>